<template>
  <div>
    <div v-for="(item, n) in meters" :key="`${n}-gas`">
      <package-editable-box :isElectricMeter="false" :isGasMeter="true" :packageKey="item.technicalCharacteristic"
        :isPriceToBeDetermined="false" :excludingVatPrice="0" :meterCount="item.count"
        :maximumPowerGuaranteed="item.power" :identifier="n" :buildingType="buildingType" :onEdit="editGasBox"
        :onDelete="deleteGasBox"></package-editable-box>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { GasMeter } from '@/models'
import PackageEditableBox from './PackageEditableBox.vue'

@Component({
  components: {
    PackageEditableBox
  },
  name: 'package-gas'
})
export default class PackageGas extends Vue {
  @Prop({ type: Array, required: true }) public meters!: GasMeter[]
  @Prop({ type: String, required: true }) public buildingType!: string

  @Prop({ type: Function, required: true }) public editGasBox!: (identifier: number) => void
  @Prop({ type: Function, required: true }) public deleteGasBox!: (identifier: number) => void

}
</script>